import { IonGrid, IonBadge, IonCard, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { mailOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';

import Vault from '../components/Vault';
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 
import '../pages/ChatMsg.css'; 

  
const LiveChatContent : React.FC<ContentInterface> = ({ content }) => {
    
    const router = useIonRouter();

    // go to chat box
    const gotoChat = () => {
        router.push("/chatmsg/" + content.user + "/thread", "forward", "push");
    }

    return (
        <div className="live-chat-content">
            <IonCard className="flat-card ion-no-margin">
                { /* user title */ }
                <IonItem id="nc-content" lines="none">
                    <IonAvatar slot="start">
                        <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                    </IonAvatar>
                    <IonLabel className="ion-text-wrap">
                    <h2>
                        <b>{ content.user_name }</b>
                    </h2>
                    <IonNote>{ GetStr(LANGUAGE.TXT_PUBLIC_CHAT_TAG) }</IonNote>
                </IonLabel>
                </IonItem>
                { /* live chat */ }
                {
                    content.title != "" ?
                <IonGrid className="full-width ion-padding">
                    <IonRow>
                        <IonCol className="right-avt-pad">
                            <div className="msg-right">
                                <IonBadge className="msg msg-text">
                                    { content.title }
                                </IonBadge>
                            </div>
                            <div className="timestamp ion-text-right" >
                                { content.time }
                            </div>
                        </IonCol>
                        <IonCol className="avt-col">
                            <IonAvatar className="avt-size">
                                <img src={ content.thumbnail } onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                            </IonAvatar>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                    :
                <div/>
                }
                <IonButton className="main-but profile-but ion-margin" fill="clear" expand="block" color="dark" onClick={ gotoChat }>
                    <IonIcon icon={mailOutline} />&nbsp;&nbsp;
                    { GetStr(LANGUAGE.TXT_PUBLIC_CHAT_JOIN) }
                </IonButton>
            </IonCard>
        </div>
    );
};
  
export default LiveChatContent;